module.exports = __webpack_public_path__ + "media/images/top/icon/black/ico_close-af9d660a92397a3b1f5e5683471ae252.svg";